module.exports = __webpack_public_path__ + "img/8.937a2ee8.png";